import {remCalc} from '../_utils'

const shadows = {
    borderShadow: `0px 0px ${remCalc(4)} 0px rgba(0, 0, 0, 0.15)`,
    borderShadowBottom: `0px ${remCalc(4)} ${remCalc(4)} 0px rgba(0, 0, 0, 0.15)`,
}

export default shadows
